/*-----------------------------------------------------------------
- Video Audio routes
-----------------------------------------------------------------*/
const prefix = 'video-audio-images';
const routes = [
    {
        path     : 'video-audio-images',
        name     : `${prefix}`,
        component: () => import('@modules/video-audio/views/VideoAudio.vue'),
    },

];

export default routes;
